import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";
import { reveal, container } from "../lib/motion";
import { useLead } from "../context/LeadContext";

const POINTS = ["Online presence", "Content strategy", "Website & UX", "Google visibility", "Lead generation"];

export const Audit = () => {
  const { openLead } = useLead();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section id="audit" ref={ref} className="relative overflow-hidden bg-ink py-24 md:py-32">
      <motion.div style={{ y }} className="pointer-events-none absolute -left-20 top-1/4 h-[420px] w-[420px] rounded-full bg-teal/20 blur-[120px]" />
      <div className="pointer-events-none absolute right-0 top-0 select-none font-display text-[24vw] font-black leading-none tracking-tighter text-white/[0.03] md:text-[18vw]">AUDIT</div>

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }} className="grid gap-12 md:grid-cols-12 md:items-center">
          <div className="md:col-span-7">
            <motion.span variants={reveal} className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-teal">
              <MagnifyingGlass size={16} weight="bold" /> Marketing Growth Audit
            </motion.span>
            <motion.h2 variants={reveal} className="font-display text-4xl font-semibold leading-[0.95] tracking-tighter text-white md:text-6xl" data-testid="audit-headline">
              Not Sure What Your Marketing Is Missing?
            </motion.h2>
            <motion.p variants={reveal} className="mt-6 max-w-xl font-sans text-lg leading-relaxed text-zinc-400">
              Our Marketing Growth Audit helps identify gaps in your online presence, content strategy, website, Google visibility, and lead generation process.
            </motion.p>
            <motion.button
              variants={reveal} onClick={() => openLead("audit")} data-testid="audit-start-button"
              className="group mt-10 flex items-center gap-3 bg-teal px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-ink"
            >
              Start Your Marketing Audit <ArrowRight weight="bold" className="transition-transform group-hover:translate-x-1" />
            </motion.button>
          </div>

          <motion.ul variants={reveal} className="md:col-span-5 md:border-l md:border-white/10 md:pl-10">
            {POINTS.map((p, i) => (
              <li key={p} className="flex items-center justify-between border-b border-white/10 py-4">
                <span className="font-display text-lg font-medium text-white md:text-xl">{p}</span>
                <span className="font-display text-sm font-bold text-teal">{String(i + 1).padStart(2, "0")}</span>
              </li>
            ))}
          </motion.ul>
        </motion.div>
      </div>
    </section>
  );
};
